/**
 * Meta attribution (1NOW-11122): the `_fbp` / `_fbc` cookies and the landing
 * `fbclid`, sent with the renter-site booking-create so the backend can report
 * the booking to Meta's Conversions API with the same identity as the browser.
 */
import { storageGet, storageSet } from "utils/safeStorage";

const KEY = "metaLandingFbclid";

const cookie = (name: string): string => {
  try {
    const hit = document.cookie
      .split("; ")
      .find((c) => c.startsWith(`${name}=`));
    return hit ? decodeURIComponent(hit.slice(name.length + 1)) : "";
  } catch {
    return "";
  }
};

/** Call once at boot: the fbclid is only in the URL on the landing page. */
export function captureLandingFbclid(): void {
  try {
    if (typeof window === "undefined" || storageGet("session", KEY)) return;
    const fbclid = new URLSearchParams(window.location.search).get("fbclid");
    if (fbclid)
      storageSet("session", KEY, JSON.stringify({ fbclid, at: Date.now() }));
  } catch {
    /* no attribution is better than a broken page */
  }
}

/** `fb.1.<ms timestamp>.<fbclid>`, Meta's documented fbc format. */
export const buildFbc = (fbclid: string, at: number): string =>
  `fb.1.${at}.${fbclid}`;

/** Empty when there is nothing to send (visitor did not come from Meta). */
export function getMetaAttribution(): {
  fbp?: string;
  fbc?: string;
  fbclid?: string;
} {
  let fbclid = "";
  let at = Date.now();
  try {
    const stored = JSON.parse(storageGet("session", KEY) || "null");
    if (stored?.fbclid) {
      fbclid = String(stored.fbclid);
      at = Number(stored.at) || at;
    }
  } catch {
    /* ignore a corrupt value */
  }
  const fbp = cookie("_fbp");
  const fbc = cookie("_fbc") || (fbclid ? buildFbc(fbclid, at) : "");
  const out: { fbp?: string; fbc?: string; fbclid?: string } = {};
  if (fbp) out.fbp = fbp;
  if (fbc) out.fbc = fbc;
  if (fbclid) out.fbclid = fbclid;
  return out;
}
